import React, {Component} from 'react';
import {OrganizationChart} from 'primereact/organizationchart';
import axios from '../../axios-url';

export default class PositionChart extends Component {

    constructor() {
        super();
        this.state = {
            data: [],
            selection: [],
            isLoaded: false,
            loading: true
        };
        this.nodeTemplate = this.nodeTemplate.bind(this);
        this.getInitialData = this.getInitialData.bind(this);
        this.returnJsx = this.returnJsx.bind(this);
    }

    getInitialData(){
        this.setState({loading: true});
        axios.get('/master/api/Employee/GetPositionHierachy').then(response => {
            if (response.status === 200) {
                let data = response.data;
                this.setState({data, selection: [], loading:false, isLoaded: true});
            }
        }).catch(err => {
            this.growl.show({ severity: 'error', summary: null, detail: 'Head Count Fetch Failed' });
            this.setState({loading:false, HCEType:''});
        })
    };

    componentDidMount() {
        this.getInitialData();
    }    

    nodeTemplate(node) {
        if (node.type === "person") {
            return (
                <div>
                    <div className="node-header">{node.label}</div>
                    <div className="node-content">
                        {/* <img alt={node.data.avatar} src={`assets/demo/images/organization/${node.data.avatar}`} style={{ width: '32px' }}/>*/}
                        <div>{node.data.name}</div> 
                    </div>
                </div>
            );
        }

        if (node.type === "department") {
            return node.label;
        }
    }

    returnJsx(){
        return this.state.isLoaded ? (
            <div className="p-col-12">
                <OrganizationChart 
                    value={this.state.data} 
                    nodeTemplate={this.nodeTemplate}
                    className="p-col-11"
                    style={{transform: "scale(0.8)", transformOrigin: "center"}}>
                </OrganizationChart>
            </div>
        ) : null;
    };

    render() {
        return (
            <div className="p-grid" >
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Position Chart</h1>
                        <div className="p-grid" style={{overflow: "scroll"}}>
                            {this.returnJsx()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
